/** structure variables */
const structure = {
	nav_width_closed: '80px',
	nav_width_open: '250px',
	form_max_width: '1250px',
};

export default structure;
